import {styled} from '@mui/material/styles';
import React from 'react';

import PageLayoutEnum from '../../enum/pageLayout';
import Header from '../../layout/Header/Header';
import Sidebar from '../../layout/Sidebar/Sidebar';

const StyledWrapperMain = styled('main')(({theme}) => ({
  width: '100%',
  padding: theme.spacing(2),
  flex: '1 1 100%',
  display: 'flex',
  flexDirection: 'column',
  '& .MuiCheckbox-root,& .MuiRadio-root': {
    '&:not(.Mui-disabled)': {
      color: theme.palette.primary.main,
    },
  },
}));

const StyledWrapperSection = styled('section')(({theme}) => ({
  flex: '0 1 calc(100% - 200px)',
  maxWidth: 'calc(100% - 200px)',
  marginLeft: 'auto',
  background: theme.palette.grey[100],
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  '&.page-layout-details': {
    background: theme.palette.primary.light2,
  },
  '&.page-layout-full-width': {
    flex: '0 1 100%',
    width: '100%',
    margin: 'unset',
    maxWidth: '100%',
  },
}));

function PageContainer(props) {
  const layout = props.layout || PageLayoutEnum.LISTING;

  return (
    <>
      {layout !== PageLayoutEnum.FULL_WIDTH && <Sidebar finalNavBarList={props.finalNavBarList} />}
      <StyledWrapperSection className={`page-layout-${layout}`}>
        <Header />
        <StyledWrapperMain>{props.children}</StyledWrapperMain>
      </StyledWrapperSection>
    </>
  );
}

export default PageContainer;
